"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = VerifyRouting;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _VerifyRouting = require("./VerifyRouting.styles");
var _index = require("../../../utils/index");
var _CheckImage = _interopRequireDefault(require("./CheckImage"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function VerifyRouting(_ref) {
  var institution = _ref.institution,
    routingNumber = _ref.routingNumber;
  var classes = (0, _VerifyRouting.useStyles)();
  var fieldProps = {
    required: true,
    fullWidth: true
  };
  var inputProps = routingNumber.inputProps,
    onBlur = routingNumber.onBlur,
    onChange = routingNumber.onChange,
    value = routingNumber.value,
    errors = routingNumber.errors,
    intent = routingNumber.intent,
    helperText = routingNumber.helperText;

  /* istanbul ignore next */
  var routingProps = _objectSpread(_objectSpread({}, fieldProps), {}, {
    id: 'plaidRoutingNumber',
    name: 'routingNumber',
    label: (0, _index.generateBankLabel)('Routing Number', institution),
    onBlur: onBlur,
    onChange: onChange,
    value: value,
    intent: errors && errors.message ? 'error' : null || intent,
    helperText: errors && errors.message ? errors.message : null || helperText,
    inputProps: inputProps
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-testid": "verify-routing-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.fieldWrap
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.TextField, routingProps)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageWrap
  }, /*#__PURE__*/_react["default"].createElement(_CheckImage["default"], null)));
}
VerifyRouting.propTypes = {
  /**
   * An institution name.
   */
  institution: _propTypes.string,
  /**
   * A configuration object for the Routing number field
   *
   */
  routingNumber: (0, _propTypes.shape)({
    onBlur: _propTypes.func,
    onChange: _propTypes.func,
    value: _propTypes.string,
    inputProps: (0, _propTypes.shape)({}),
    errors: (0, _propTypes.shape)({
      code: _propTypes.string,
      message: _propTypes.string
    })
  }).isRequired
};
VerifyRouting.defaultProps = {
  institution: ''
};
